import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core';

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { baseTheme } from '../../theme';

import PostListItem from '../../components/post-components/post-list-item';
import PostListEmpty from '../../components/post-components/post-list-empty';
import PostListActionBar from '../../components/post-components/post-list-action-bar';
import PostComponent from '../../components/post-components/post-component';

import { getPostsAction, getPostDetailsAction, deletePostAction } from '../../store';

import {
  deletePost,
} from '../../services';
import { setSelectedPostAction } from '../../store/posts/actions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingRight: theme.spacing(0),
      paddingLeft: theme.spacing(0),
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      maxHeight: '100vh',
    },
    pageHeading: {
      fontSize: '1.6em',
      color: theme.palette.primary.main,
      fontWeight: 'normal',
      padding: theme.spacing(0),
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(2),
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(2),
    },
    listRoot: {
      paddingRight: theme.spacing(0),
      paddingLeft: theme.spacing(0),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      transition: theme.transitions.create('all', {
        duration: theme.transitions.duration.enteringScreen,
      }),
    },

  }),
);

export default function ListPostsPage() {
  const classes = useStyles(baseTheme);
  const dispatch = useDispatch();
  const selectedPost = useSelector((state: any) => state.posts.selected?.id);
  const [allowEditPost, setAllowEditPost] = useState<Boolean>(true);
  const [initalLoad, setInitialLoad] = useState<Boolean>(true);
  const editId = useSelector((state: any) => state.posts.selected);
  const posts = useSelector((state: any) => state.posts.list);
  const listConfig = useSelector((state: any) => state.posts.listConfig);
  const currUser = useSelector((state: any) => state.auth.currUser);

  useEffect(() => {
    if (currUser.uid && initalLoad) {
      getPostsAction(currUser.uid, listConfig, dispatch);
    }

    if (posts.length > 0) {
      setInitialLoad(false);
    }
  }, [listConfig, dispatch, currUser, posts, initalLoad]);

  const isSelected = (id: string) => selectedPost === id;
  const editEnabled = editId ? true : false;

  const setEditPost = (value: string | null) => {
    // setSelectedPost(value);
    getPostDetailsAction(value, dispatch);
    const postComponentBox = document.getElementById('postComponentBox');
    if (postComponentBox) {
      postComponentBox.scrollTo({ top: 0 });
    }
  };

  const selectPost = (data: any) => {
    selectedPost === data
      ? setEditPost(null)
      : setEditPost(data);
  };

  const handleDeletePost = async (postId: string) => {
    await deletePost(postId);
    dispatch(setSelectedPostAction(null));
    getPostsAction(currUser.uid, listConfig, dispatch);
  };

  const listPosts = () => {
    if (posts?.length) {
      return posts.map((item: any, index: number) => {
        return <PostListItem
          key={index}
          {...item}
          post={item}
          allowEditPost={allowEditPost}
          setAllowEditPost={setAllowEditPost}
          selectPost={selectPost}
          deletePost={handleDeletePost}
          selected={isSelected(item.id)} />;
      });
    }
    return (
      <div className={classes.listRoot}>
        <h4>No Results Found</h4>
      </div>
    );
  };

  const listResults = () => (
    <Grid item
      container
      direction="column"
      className={classes.listRoot}>
      <PostListActionBar editEnabled={editEnabled} />

      <Grid item container direction="column">
        {listPosts()}
      </Grid>
    </Grid>
  );

  const emptyList = () => {
    return (
      <PostListEmpty />
    );
  };

  return (

    <Grid item container={editEnabled} direction="row" wrap="nowrap" className={classes.root}>
      <Box
        style={{
          maxHeight: '100vh',
          overflow: 'auto',
          maxWidth: editEnabled ? '33vw' : '100vw',
        }}>
          {initalLoad ?
            emptyList() :
            listResults()
          }
      </Box>
      <Box
        id="postComponentBox"
        style={{
          maxHeight: '100vh',
          overflow: 'auto',
          maxWidth: '66vw',
        }}>
          {editEnabled ?
              <PostComponent checked={editEnabled} /> :
              null}
      </Box>
    </Grid >
  );
}
